import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const FragmentActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

FragmentActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

FragmentActions.defaultProps = {
  basePath: '',
  data: {},
};

export default FragmentActions;
